import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DwLanguageService } from '@webdpt/framework';
import { Fxed020S01Component } from './fxed020-s01.component';

const routes: Routes = [
  {
    path: 'home',
    pathMatch: 'prefix',
   component: Fxed020S01Component,
    data: {
      dwRouteData: {
        programId: 'fxed020'
      },
      i18n: ['common']
    },
    resolve: { // 多语系
      transaction: DwLanguageService
    },
    loadChildren: './fxed020-pages/fxed020-pages.module#Fxed020PagesModule'
    // children: [
    //   {
    //     path: '',
    //     pathMatch: 'prefix',
    //     // component: Fxed020S01Component,
    //     loadChildren: './fxed020-pages/fxed020-pages.module#Fxed020PagesModule',
    //     // children: [
    //     //   //dwAttachTabbedRoutes(MODULE_ROUTES),
    //     //   ...MODULE_ROUTES
    //     // ]
    //   }
    // ]
  },
  // {
  //   path: 'car',
  //   pathMatch: 'prefix',
  //   component: Fxed020CarComponent,
  // },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Fxed020RoutingModule { }
